/** Per-target (journal, account, third party, entries) state of the push to Billy. */
export enum FecPushStatus {
  NotPushed = 'not_pushed',
  Pushed = 'pushed',
  Pushing = 'pushing',
  PushFailed = 'push_failed',
}
